var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/core-js/modules/es7.reflect.define-metadata.js
// module id = ../../../../core-js/modules/es7.reflect.define-metadata.js
// module chunks = 0